// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../../shared/reducers/busy-counter';
import claim from './mass-channel-pdi-claim';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import createClaimModal from './create-claim-modal';
import formValidation from './form-validation';
import isActionButtonDisabled from './is-action-button-disabled';
import isCopied from './is-copied';
import isEditable from './is-editable';
import isStickyHeaderVisible from './is-sticky-header-visible';
import isValidClaim from './is-valid-claim';
import retailerNameCollection from './retailer-name-collection';
import temporaryObjectKey from './temporary-object-key';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claim,
    confirmationModal,
    createClaimModal,
    formValidation,
    isActionButtonDisabled,
    isCopied,
    isEditable,
    isStickyHeaderVisible,
    isValidClaim,
    retailerNameCollection,
    temporaryObjectKey
});




// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/reducers/index.js